import axiosInstance from "../../../helpers/api";

export const getLiveVideos = (body) => {
  return axiosInstance.get("/admin/live_videos", body);
};

export const createLiveVideo = (formData) => {
  return axiosInstance.post("/superadmin/live-videos", formData);
};

export const livevideoReport = (id) => {
  return axiosInstance.get(`/admin/live_videos/${id}`);
};

// List Students Not Attending Zoom
export const getAbsentStudents = (id) => {
  return axiosInstance.get(`/admin/live_videos/list_absent/${id}`);
};

// Notify Parent For Live Absence
export const notifyForAbsence = (data) => {
  return axiosInstance.post("/admin/live_videos/notify_for_absence", data);
};
